import React, { useState, useEffect } from 'react';

export function GalleryModal({ images, isOpen, initialIndex = 0, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);

  useEffect(() => {
    function handleKeyDown(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') handleNext();
      if (e.key === 'ArrowLeft') handlePrev();
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, currentIndex, images]);

  if (!isOpen || !images || images.length === 0) return null;

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-xs flex items-center justify-center p-4 animate-in fade-in duration-200"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Billedgalleri stor visning"
    >
      <div 
        className="relative max-w-5xl w-full max-h-[90vh] flex flex-col items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          type="button"
          className="absolute -top-12 right-0 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 p-2.5 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#3885B8]"
          aria-label="Luk galleri"
        >
          <i className="fa-solid fa-xmark text-xl" aria-hidden="true" />
        </button>

        {/* Current Image */}
        <div className="relative overflow-hidden rounded-xl bg-black/40 shadow-2xl max-h-[75vh] flex items-center justify-center">
          <img
            src={images[currentIndex]}
            alt={`Galleri billede ${currentIndex + 1} af ${images.length}`}
            className="max-h-[75vh] max-w-full object-contain select-none"
          />
        </div>

        {/* Controls Bar */}
        <div className="mt-4 flex items-center justify-between w-full max-w-md px-4 text-white">
          <button
            onClick={handlePrev}
            type="button"
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[#3885B8]"
            aria-label="Forrige billede"
          >
            <i className="fa-solid fa-chevron-left" aria-hidden="true" />
            <span className="hidden sm:inline">Forrige</span>
          </button>

          <span className="text-sm font-medium text-white/70">
            {currentIndex + 1} / {images.length}
          </span>

          <button
            onClick={handleNext}
            type="button"
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[#3885B8]"
            aria-label="Næste billede"
          >
            <span className="hidden sm:inline">Næste</span>
            <i className="fa-solid fa-chevron-right" aria-hidden="true" />
          </button>
        </div>

      </div>
    </div>
  );
}
